export default __webpack_public_path__ + "static/media/UserExperienceEnsurance_Image.0956364a.png";